import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const GDPRBanner = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useI18n();

  useEffect(() => {
    const consent = localStorage.getItem("gdpr-consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem("gdpr-consent", "acknowledged");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <motion.div
      data-hide-on-keyboard="true"
      initial={{ y: 60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 60, opacity: 0 }}
      className="fixed bottom-[5.5rem] md:bottom-4 left-0 right-0 z-[60] px-3 sm:px-4"
    >
      <div className="mx-auto max-w-xl rounded-xl bg-card/95 backdrop-blur-md border border-border px-4 py-3 shadow-elevated">
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3">
          <p className="text-xs text-muted-foreground text-center sm:text-left flex-1 leading-snug">
            <Cookie className="h-3.5 w-3.5 shrink-0 text-primary" /> {t("gdpr.description")}{" "}
            <a href="/privacy" className="text-primary underline hover:no-underline">
              {t("gdpr.readPolicy")}
            </a>
          </p>
          <Button onClick={dismiss} size="sm" className="h-7 px-3 text-xs shrink-0">
            {t("gdpr.accept")}
          </Button>
        </div>
      </div>
    </motion.div>
  );
};

export default GDPRBanner;
